import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { navigate, Link } from "gatsby"
import { FilterChip } from '@cdm/quickenloans-library/lib'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import { topicsFilterContainer, topicsFilterWrapper, tocpicsGobackBtn } from './TopicsFilter.module.scss';
import { testAttributes } from './Constants';

const TopicsFilter = ({ topics }) => 
{
    return <div className={`qld-gridparent ${topicsFilterContainer}`} data-testid={testAttributes.TOPICS_FILTER_CONTAINER}>
        <div className={topicsFilterWrapper}>
            {
                topics.map((topic) => {
                    return topic.isFilter ?  (
                        <Link to={topic.link}>
                            <FilterChip 
                                key={`topic-${topic.id}`} 
                                {...topic} 
                                testId={`item-filter-${topic.id}`}
                                label={topic.component || topic.label}
                            />
                        </Link>
                    ) : (
                        <Link className={tocpicsGobackBtn} key={`topic-${topic.id}`} data-testid={`item-filter-${topic.id}`} to={topic.link}>
                            <ArrowBackIcon />
                            <span>{topic.label}</span>
                        </Link>
                    )
                })
            }
        </div>
    </div>
};
 
TopicsFilter.propTypes = {
    /** The list of topics to be displayed */
    topics: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number.isRequired,
            label: PropTypes.string.isRequired,
            isChecked: PropTypes.bool,
            link: PropTypes.string.isRequired,
        })
    ).isRequired,
};

export default TopicsFilter;